import { Typography } from '@altibox/lte-salgskanaler-design-system-component-lib';
import { styled } from 'styled-components';

import { Image } from 'src/components/image';
import { breakpointLargeTablet } from 'src/styles/breakpoints';
import { colorCommon80, colorPrimary100 } from 'src/styles/colors';
import { spacing1, spacing2 } from 'src/styles/spacing';

const ICON_HEIGHT = '20px';

export const StyledAlert = styled.div`
  background: ${colorPrimary100};
  border-radius: 6px;
  border: 1px solid ${colorCommon80};
  padding: ${spacing2};

  &:not(:last-child) {
    margin-bottom: ${spacing1};

    @media (min-width: ${breakpointLargeTablet}) {
      margin-bottom: ${spacing2};
    }
  }
`;

export const StyledWrapper = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: ${spacing2};
`;

export const StyledIcon = styled(Image)`
  max-height: ${ICON_HEIGHT};
  margin-right: ${spacing2};
`;

export const StyledTitle = styled(Typography)`
  font-weight: bold;
`;
